export function formatToTwDate(date) {
    if (!date) {
        return '';
    }
    if (typeof date === 'string') {
        date = new Date(date);
    }
    if (date === null) {
        return '';
    }
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear() - 1911;
    return `${year}/${month < 10 ? '0' + month : month}/${day < 10 ? '0' + day : day}`;
}
